// === Custom Reveal Animations for Shopify ===
function initRevealAnimations(context = document) {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal-visible');
        observer.unobserve(entry.target); // 🔥 SOLO UNA VEZ
      }
    });
  }, { threshold: 0.18 });

  const elements = context.querySelectorAll('.reveal, .reveal-right, .reveal-left, .reveal-top');

  elements.forEach(el => {
    revealObserver.observe(el);
  });
}

// Ejecutar al cargar la página
document.addEventListener('DOMContentLoaded', () => {
  initRevealAnimations();
});

// Ejecutar cuando Shopify renderiza secciones dinámicas
document.addEventListener('shopify:section:load', (event) => {
  initRevealAnimations(event.target);
});


function loadContent() {
  const path = window.location.pathname.toLowerCase();
  const container = document.getElementById('faq-content');
  const title = document.getElementById('title');

  if (path.includes('/ca')) {
    container.innerHTML = contentCA;
    title.textContent = 'Qui som';
  } else {
    container.innerHTML = contentES;
    title.textContent = 'Quiénes somos';
  }

  // ⚡️ Muy importante: esperar a que el DOM renderice los <details>
  setTimeout(() => {
    initRevealAnimations(container);
  }, 50); // 50ms basta para que se procesen los elementos
}
// Ejecutar al cargar la página
window.addEventListener('DOMContentLoaded', loadContent);

// Ejecutar cuando Shopify carga secciones dinámicas
document.addEventListener('shopify:section:load', (event) => {
  loadContent();
});

